import { cn } from "@discovery/classnames";
import * as styles from "./styles.css";
export const FloatingLabel = ({ label, handleInput, value, onFocusOut, onKeyUpM, customStyle, customTextStyle, maxLength = 25, }) => (React.createElement("div", { className: styles.floatingLabel },
    React.createElement("input", { className: cn(styles.floatingInput, customStyle), type: "text", placeholder: " ", onChange: (e) => handleInput(e), value: value, maxLength: maxLength, onBlur: (e) => onFocusOut && onFocusOut(e), onKeyUp: onKeyUpM }),
    React.createElement("label", { className: cn(styles.labelTxt, customTextStyle) }, label)));

